export default "__VITE_ASSET__2716f86f__"